/* ===========================
   MANDALEON THEME - MAIN JS
   =========================== */

(function() {
  'use strict';

  // ===========================
  // CART
  // ===========================

  const Cart = {
    overlay: null,
    sidebar: null,

    init() {
      this.overlay = document.getElementById('cart-overlay');
      this.sidebar = document.getElementById('cart-sidebar');

      document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
        btn.addEventListener('click', () => this.open());
      });

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      const closeBtn = document.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });

      this.fetchCart();
    },

    open() {
      this.sidebar?.classList.add('is-open');
      this.overlay?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.sidebar?.classList.remove('is-open');
      this.overlay?.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    async fetchCart() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.updateCount(cart.item_count);
        this.renderItems(cart);
      } catch (e) {
        console.warn('Cart fetch error:', e);
      }
    },

    updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    },

    renderItems(cart) {
      const container = document.getElementById('cart-items');
      const emptyEl = document.getElementById('cart-empty');
      const footerEl = document.getElementById('cart-footer');
      const subtotalEl = document.getElementById('cart-subtotal-price');

      if (!container) return;

      if (cart.item_count === 0) {
        container.innerHTML = '';
        if (emptyEl) emptyEl.style.display = 'flex';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      if (emptyEl) emptyEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'block';

      if (subtotalEl) {
        subtotalEl.textContent = this.formatMoney(cart.total_price);
      }

      container.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <img
            class="cart-item__img"
            src="${item.image ? item.image : ''}"
            alt="${item.product_title}"
            loading="lazy"
          />
          <div>
            <div class="cart-item__title">${item.product_title}</div>
            <div class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
            <div class="cart-item__price">${this.formatMoney(item.price)}</div>
            <div style="display:flex; align-items:center; gap:8px; margin-top:8px;">
              <button onclick="MandaleonCart.updateItem('${item.key}', ${item.quantity - 1})"
                style="width:24px; height:24px; border:1px solid var(--color-pink-medium); background:none; cursor:pointer; border-radius:2px; font-size:0.9rem; display:flex; align-items:center; justify-content:center;">−</button>
              <span style="font-size:0.85rem; min-width:20px; text-align:center;">${item.quantity}</span>
              <button onclick="MandaleonCart.updateItem('${item.key}', ${item.quantity + 1})"
                style="width:24px; height:24px; border:1px solid var(--color-pink-medium); background:none; cursor:pointer; border-radius:2px; font-size:0.9rem; display:flex; align-items:center; justify-content:center;">+</button>
              <button onclick="MandaleonCart.updateItem('${item.key}', 0)"
                style="margin-left:8px; background:none; border:none; cursor:pointer; font-size:0.75rem; color:var(--color-text-light); text-decoration:underline;">Eliminar</button>
            </div>
          </div>
        </div>
      `).join('');
    },

    formatMoney(cents) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN'
      }).format(cents / 100);
    },

    async addItem(variantId, quantity = 1) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });
        if (res.ok) {
          await this.fetchCart();
          this.open();
        }
      } catch (e) {
        console.warn('Add to cart error:', e);
      }
    },

    async updateItem(key, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (res.ok) {
          await this.fetchCart();
        }
      } catch (e) {
        console.warn('Update cart error:', e);
      }
    }
  };

  // ===========================
  // PRODUCT PAGE
  // ===========================

  const ProductPage = {
    init() {
      if (!document.getElementById('product-form')) return;

      this.initGallery();
      this.initVariants();
      this.initAddToCart();
    },

    initGallery() {
      const mainImg = document.getElementById('main-product-image');
      const thumbs = document.querySelectorAll('.product-gallery__thumb');

      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const img = thumb.querySelector('img');
          if (mainImg && img) {
            mainImg.src = img.src.replace('200x267', '700x933');
            mainImg.srcset = '';
          }
          thumbs.forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        });
      });
    },

    initVariants() {
      const variants = window.productVariants || [];
      const options = window.productOptions || [];
      const selectedOptions = [];

      const sizeButtons = document.querySelectorAll('.size-option');
      sizeButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = parseInt(btn.dataset.optionIndex);
          const val = btn.dataset.optionValue;

          // Deselect siblings
          document.querySelectorAll(`.size-option[data-option-index="${idx}"]`).forEach(b => {
            b.classList.remove('selected');
          });
          btn.classList.add('selected');

          selectedOptions[idx] = val;

          // Find matching variant
          const matched = variants.find(v => {
            return v.options.every((o, i) => !selectedOptions[i] || o === selectedOptions[i]);
          });

          if (matched) {
            document.getElementById('selected-variant').value = matched.id;

            const priceEl = document.getElementById('product-price');
            const comparePriceEl = document.getElementById('product-compare-price');
            const addBtn = document.getElementById('add-to-cart-btn');

            if (priceEl) priceEl.textContent = Cart.formatMoney(matched.price);
            if (comparePriceEl) {
              if (matched.compare_at_price > matched.price) {
                comparePriceEl.textContent = Cart.formatMoney(matched.compare_at_price);
                comparePriceEl.style.display = 'inline';
              } else {
                comparePriceEl.style.display = 'none';
              }
            }
            if (addBtn) {
              addBtn.disabled = !matched.available;
              addBtn.textContent = matched.available ? 'Agregar al carrito' : 'Sin stock';
            }
          }
        });
      });
    },

    initAddToCart() {
      const form = document.getElementById('product-form');
      if (!form) return;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const variantId = document.getElementById('selected-variant')?.value;
        if (!variantId) return;

        const btn = document.getElementById('add-to-cart-btn');
        const originalText = btn?.textContent;

        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Agregando...';
        }

        await Cart.addItem(variantId);

        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
      });
    }
  };

  // ===========================
  // MOBILE MENU
  // ===========================

  const MobileMenu = {
    init() {
      const toggle = document.getElementById('mobile-menu-toggle');
      const menu = document.getElementById('mobile-menu');
      const close = document.getElementById('mobile-menu-close');

      toggle?.addEventListener('click', () => {
        menu?.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        toggle.setAttribute('aria-expanded', 'true');
      });

      close?.addEventListener('click', () => {
        menu?.classList.remove('is-open');
        document.body.style.overflow = '';
        toggle?.setAttribute('aria-expanded', 'false');
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          menu?.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }
  };

  // ===========================
  // HEADER SCROLL
  // ===========================

  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        header.style.boxShadow = '0 4px 30px rgba(200,37,74,0.1)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  // ===========================
  // INIT
  // ===========================

  document.addEventListener('DOMContentLoaded', () => {
    Cart.init();
    ProductPage.init();
    MobileMenu.init();
    initHeaderScroll();
  });

  window.MandaleonCart = Cart;

  // BACK BUTTON — guarda scroll y filtros al salir de colección
document.querySelectorAll('.product-card__image-wrap, .product-card__title').forEach(function(el) {
  el.addEventListener('click', function() {
    sessionStorage.setItem('scrollPos', window.scrollY);
    sessionStorage.setItem('fromCollection', window.location.href);
  });
});

// Al cargar página de producto, restaura al volver
if (window.location.pathname.includes('/products/')) {
  var backUrl = sessionStorage.getItem('fromCollection');
  var backBtn = document.getElementById('back-to-collection');
  if (backBtn && backUrl) {
    backBtn.href = backUrl;
    backBtn.style.display = 'inline-flex';
  }
}

// Al cargar colección, restaura scroll
if (sessionStorage.getItem('scrollPos') && sessionStorage.getItem('fromCollection') === window.location.href) {
  window.scrollTo(0, parseInt(sessionStorage.getItem('scrollPos')));
  sessionStorage.removeItem('scrollPos');
  sessionStorage.removeItem('fromCollection');
}

})();
